const ANONYMOUS_PROJECT_KEY = 'wegic_anonymous_project_id';

/**
 * 获取匿名项目 ID
 */
export function getAnonymousProjectId(): string | null {
  try {
    return localStorage.getItem(ANONYMOUS_PROJECT_KEY);
  } catch {
    return null;
  }
}

/**
 * 设置匿名项目 ID
 */
export function setAnonymousProjectId(projectId: string): void {
  try {
    localStorage.setItem(ANONYMOUS_PROJECT_KEY, projectId);
  } catch {}
}

/**
 * 清除匿名项目 ID
 */
export function clearAnonymousProjectId(): void {
  try {
    localStorage.removeItem(ANONYMOUS_PROJECT_KEY);
  } catch {}
}
